import classNames from 'classnames';
import IconButton from 'features/targetingV2/components/core/IconButton';
import Loader from 'features/targetingV2/components/core/Loader';
import Menu from 'features/targetingV2/components/core/Menu/Menu';
import MenuItem from 'features/targetingV2/components/core/MenuItem';
import Typography from 'features/targetingV2/components/core/Typography';
import { IOptionType } from 'features/targetingV2/types/common';
import React, { useState } from 'react';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import useStyles from './AddParameterDropdownButton.styles';

export interface IAddParameterDropdownButtonProps {
  options: IOptionType[];
  onOptionClick: (value: string) => void;
  disabled?: boolean;
  loading?: boolean;
  testId?: string;
}
const AddParameterDropdownButton = (
  props: IAddParameterDropdownButtonProps
) => {
  const classes = useStyles();

  const {
    options,
    onOptionClick,
    disabled = false,
    loading = false,
    testId = 'add-parameter-dropdown-button',
  } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-controls={open ? 'icon-button-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpenMenu}
        disableRipple
        classes={{
          root: classNames(classes.menuIconButton, {
            [`${classes.menuIconButton}--open`]: open,
          }),
        }}
        disabled={disabled}
        data-testid={testId}
      >
        <Typography variant="body2">Add</Typography>
        {open ? (
          <ExpandLess data-testid="expandLessIcon" />
        ) : (
          <ExpandMore data-testid="expandMoreIcon" />
        )}
      </IconButton>
      <Menu
        MenuListProps={{
          'aria-label': 'icon-button-menu',
        }}
        PaperProps={{
          className: classes.paper,
        }}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {loading ? (
          <MenuItem disableRipple>
            <Loader
              size={25}
              classes={{
                container: classes.progressContainer,
                progress: classes.progress,
              }}
            />
          </MenuItem>
        ) : (
          options.map((option: IOptionType) => (
            <MenuItem
              key={option.value}
              className={classes.menuItem}
              disableRipple
              onClick={() => {
                onOptionClick(option.value);
                handleClose();
              }}
            >
              <div>
                <Typography variant="body2">{option.label}</Typography>
              </div>
            </MenuItem>
          ))
        )}
      </Menu>
    </>
  );
};

export default AddParameterDropdownButton;
